import { render, staticRenderFns } from "./UpdateFormwareForm.vue?vue&type=template&id=e8d8b2de&scoped=true&"
import script from "./UpdateFormwareForm.vue?vue&type=script&lang=js&"
export * from "./UpdateFormwareForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFormwareForm.vue?vue&type=style&index=0&id=e8d8b2de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d8b2de",
  null
  
)

export default component.exports